<dx-popup
  minWidth="340px"
  width="460px"
  height="auto"
  [showTitle]="true"
  title="Developer Tools"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [(visible)]="devToolsVisible"
  (onHiding)="onCloseClick()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="dx-fieldset">
      <div class="dx-fieldset-header">Client-side errors</div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Throw JS Exception"
          [width]="220"
          (onClick)="onTestExceptionClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          Throws an uncaught
          <code>Error</code>
          . Exercises
          <code>RPErrorsHandler</code>
          (non-HTTP branch) and Datadog sourcemap linking.
        </small>
      </div>
    </div>

    <div class="dx-fieldset">
      <div class="dx-fieldset-header">
        HTTP errors — DatadogErrorInterceptor
      </div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Trigger 404 (Unhandled)"
          [width]="220"
          (onClick)="onTestHttpUnhandledClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          GET to a nonexistent backend path with no
          <code>error</code>
          callback. Interceptor reports to Datadog;
          <code>RPErrorsHandler</code>
          displays the toast but doesn't double-report.
        </small>
      </div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Trigger 404 (Caught)"
          [width]="220"
          (onClick)="onTestHttpCaughtClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          GET to a nonexistent backend path, error caught locally. Primary test:
          before the interceptor, Datadog would see nothing; now it still
          records the full error.
        </small>
      </div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Trigger Network Error"
          [width]="220"
          (onClick)="onTestNetworkErrorClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          GET to an unresolvable host (status 0). Should be dropped by
          <code>shouldDropHttpError</code>
          Filter 1; verify NO event appears in Datadog.
        </small>
      </div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Trigger 401 (Synthetic)"
          [width]="220"
          (onClick)="onTestUnauthorizedClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          Synthesizes a status-401
          <code>HttpErrorResponse</code>
          and feeds it to
          <code>addHttpError</code>
          directly (cookies block a real-network 401 trigger). Should be dropped
          by Filter 2; verify NO event appears in Datadog.
        </small>
      </div>

      <div class="form-group">
        <dx-button
          type="default"
          text="Trigger Login Failure"
          [width]="220"
          (onClick)="onTestLoginFailureClick()"
        ></dx-button>
        <br />
        <small class="text-muted">
          POSTs login with invalid credentials. identity-api returns 404
          (non-standard; tracked in DX-1071). Should be dropped by Filter 4;
          verify NO event appears in Datadog.
        </small>
      </div>
    </div>

    <dx-box direction="row" width="100%" align="end" crossAlign="center">
      <dxi-item [ratio]="1">
        <dx-button
          type="default"
          [width]="100"
          text="Close"
          (onClick)="onCloseClick()"
        ></dx-button>
      </dxi-item>
    </dx-box>
  </div>
</dx-popup>
